export default __webpack_public_path__ + "static/media/figma-logo.46400ab8.png";